import { ILocalizedError } from 'src/i18n/error-localization';

export enum ResetPasswordResult { Success, NotFound, Other }

export interface IResetPasswordState {
    result: ResetPasswordResult | undefined;
    error: ILocalizedError | null;
    isLoading: boolean;
}


// WEBPACK FOOTER //
// ./src/contracts/IResetPasswordState.ts